<stages-floating-action-menu
	*ngIf="showFloatingActionButton"
	[iconClass]="'ico ico-add'"
	[menuItems]="menuItems"
	[darkTheme]="true"
	[card]="card"
/>
